module.exports = __webpack_public_path__ + "img/cstQrcode.0a54390c.png";